<template>
  <div class="kk-tree__title-container">
    <item
      :id="id"
      :depth="depth"
      :is-active="isActive"
      :editable="editable"
      :draggable="true"
      :hash-table="playersHashTable"
      :disabled="disabled"
      @drag-start-called="dragStart"
      @drag-over-called="dragOver"
      @drop-called="drop"
      @drag-leave-called="startHideTimer"
      @drag-enter-called="dragEnter"
      @save-data="saveData"
    ></item>
    <context-menu v-if="showContextMenu" :item="item" :team-id="getTeamId(item.id)" />
    <horizontal-line v-if="showHorizontalLine" :position="position" />
  </div>
</template>

<script>
import { Positions, TreeDefaultNodeIds, HotkeyScopes } from "../../../../utils/constants";
import ContextMenu from "./ContextMenu.vue";
import HorizontalLine from "../HorizontalLine.vue";
import Item from "../Item.vue";
export default {
  components: { ContextMenu, HorizontalLine, Item },
  props: ["id", "depth", "isActive", "editable", "disabled"],
  data() {
    return {
      position: null,
      hideTimer: null,
      startTime: null,
    };
  },
  computed: {
    item() {
      return (this.playersHashTable && this.playersHashTable[this.id]) || {};
    },
    playersHashTable() {
      return this.$store.state.players.playersHashTable;
    },
    showContextMenu() {
      // dont show context menu on trash and it's immediate children
      return (
        this.activeContextMenu.id === this.item.id &&
        this.item.id !== TreeDefaultNodeIds.Trash &&
        !(this.item.parents[1] === TreeDefaultNodeIds.Trash && this.item.parents.length === 2)
      );
    },
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
    showHorizontalLine() {
      return this.position && this.position !== Positions.Center;
    },
  },
  methods: {
    async drop(e) {
      const id = e.dataTransfer.getData("id");
      this.$store.dispatch("players/movePlayer", { id, targetId: this.item.id, position: this.position });
      this.position = null;
    },
    dragOver(e) {
      if (e.dataTransfer.types.includes("player")) {
        e.dataTransfer.dropEffect = "move";

        this.calculateTimeToExpand();

        this.clearHideTimer();
        e.preventDefault();

        const target = this.$el.getBoundingClientRect();
        const piece = target.height / 4;

        if (e.y < target.top + piece) {
          this.position = Positions.Before;
        } else if (e.y > target.bottom - piece) {
          this.position = Positions.After;
        } else {
          this.position = Positions.Center;
        }
      }
    },
    startHideTimer() {
      this.hideTimer = setTimeout(() => {
        this.position = null;
        this.startTime = null;
      }, 100);
    },
    clearHideTimer() {
      clearTimeout(this.hideTimer);
    },
    calculateTimeToExpand() {
      const endTime = new Date().getTime();
      if (endTime - this.startTime > 600 && !this.item.expanded) {
        this.expandClicked();
      }
    },
    saveData(title) {
      this.$store.dispatch("players/rename", { id: this.item.id, title });
    },
    expandClicked() {
      this.$store.dispatch("players/toggleExpanded", { id: this.item.id });
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Players);
    },
    dragStart(e) {
      this.$store.dispatch("resetActiveContextMenu");
      this.$store.dispatch("players/setActiveItem", { id: e.target.dataset.id });

      e.dataTransfer.setData("id", e.target.dataset.id);
      e.dataTransfer.setData("title", e.target.dataset.title);
      e.dataTransfer.setData("player", true);

      e.dataTransfer.setDragImage(e.target, 0, 0);
    },
    dragEnter() {
      if (!this.startTime) this.startTime = new Date().getTime();
    },
    getTeamId(id) {
      return this.$store.getters["players/teamId"](id);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables";
.kk-tree__title-container {
  position: relative;
}
</style>
